import { createTheme } from "@mui/material/styles";
import { faIR } from "@mui/material/locale";
import "../Theme.types";
export const betaTheme = createTheme({
    direction: "rtl",
    palette: {
        primary: {
            main: "#513229",
            light: "#FCE6B7",
            dark: "#291914",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#8C8650",
            light: "#D7D4B1",
            dark: "#6A6639",
            contrastText: "#FFFFFF",
        },
        background: {
            default: "#F4F1E2",
            paper: "#FFFFFF",
        },
        text: {
            primary: "#3C241D",
            secondary: "#746F63",
        },
        error: {
            main: "#C10101",
            light: "#ECB0B0",
            dark: "#6A0101",
            contrastText: "#FFFFFF",
        },
        success: {
            main: "#5EC101", // G-50
            light: "#B5E28A", // G-90
            dark: "#275100", // G-20
            contrastText: "#FFFFFF", // Pure White (On-Success)
        },
        warning: {
            main: "#C19101", // Y-50
            light: "#E2CC8A", // Y-90
            dark: "#513000", // Y-20
            contrastText: "#FFFFFF", // Pure White (On-Warning)
        },
        info: {
            main: "#019EC1", // B-50
            light: "#8AD2E2", // B-90
            dark: "#004251", // B-20
            contrastText: "#FFFFFF", // Pure White (On-Info)
        },
    },
    customColors: {
        primary: {
            98: "#F8F5F4",
            95: "#EFE8E6",
            90: "#E2D0CB",
            80: "#C9A69C",
            60: "#A76A58",
            50: "#805042",
            40: "#513229",
            30: "#3C241D",
            20: "#291914",
            10: "#170F0C",
            primaryContainer: "#EFE8E6",
            onPrimaryContainer: "#170F0C",
            onPrimary: "#FFFFFF",
        },
        neutral: {
            98: "#FBFAF6",
            95: "#F6F3EA",
            90: "#EDE9DE",
            80: "#DAD6C8",
            70: "#C2BDAD",
            50: "#989281",
            40: "#746F63",
            30: "#5A5649",
            20: "#3D3A34",
            10: "#22201C",
            surfaceContainerLowest: "#FFFFFF",
            surfaceContainerLow: "#F4F1E2",
            surfaceContainer: "#F6F3EA",
            onSurface: "#3C241D",
            onSurfaceVariant: "#746F63",
            outline: "#EDE9DE",
        },
        error: {
            98: "#FDF8F8",
            95: "#F9E6E6",
            90: "#ECB0B0",
            50: "#C10101",
            20: "#6A0101",
            errorContainer: "#F9E6E6",
            onErrorContainer: "#6A0101",
            onError: "#FFFFFF",
        },
        success: {
            98: "#F4F7F1", // Background tint
            95: "#EFF9E6", // Success Container (G-95)
            90: "#B5E28A", // Container variant
            50: "#5EC101", // Main success
            20: "#275100", // Darkest
            successContainer: "#EFF9E6", // G-95
            onSuccessContainer: "#275100", // G-20 (On-Success-Container)
            onSuccess: "#FFFFFF", // Pure White
        },
        warning: {
            98: "#F9F6F4", // Background tint
            95: "#F9F4E6", // Warning Container (Y-95)
            90: "#E2CC8A", // Container variant
            50: "#C19101", // Main warning
            20: "#513000", // Darkest
            warningContainer: "#F9F4E6", // Y-95
            onWarningContainer: "#513000", // Y-20 (On-Warning-Container)
            onWarning: "#FFFFFF", // Pure White
        },
        info: {
            98: "#F2F7F8", // Background tint
            95: "#E8F5F9", // Info Container (B-95)
            90: "#8AD2E2", // Container variant
            50: "#019EC1", // Main info
            20: "#004251", // Darkest
            infoContainer: "#E8F5F9", // B-95
            onInfoContainer: "#004251", // B-20 (On-Info-Container)
            onInfo: "#FFFFFF", // Pure White
        },
    },
    typography: {
        fontFamily: ["IRANSansX", "IRANSansXBold"].join(","),
        displayLarge: {
            fontSize: "48px",
            lineHeight: "72px",
            fontWeight: 700,
            color: "#3C241D",
        },
        displaySmall: {
            fontSize: "32px",
            lineHeight: "56px",
            fontWeight: 700,
            color: "#3C241D",
        },
        headlineLarge: {
            fontSize: "24px",
            lineHeight: "44px",
            fontWeight: 700,
            color: "#3C241D",
        },
        titleLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 700,
            color: "#3C241D",
        },
        titleMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 700,
            color: "#3C241D",
        },
        labelLarge: {
            fontSize: "16px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#3C241D",
        },
        labelMedium: {
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 500,
            color: "#3C241D",
        },
        labelSmall: {
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: 500,
            color: "#3C241D",
        },
        bodyLarge: {
            fontSize: "16px",
            lineHeight: "28px",
            fontWeight: 500,
            color: "#3C241D",
        },
        bodyMedium: {
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#3C241D",
        },
        bodySmall: {
            fontSize: "12px",
            lineHeight: "24px",
            fontWeight: 500,
            color: "#3C241D",
        },
    },
}, faIR);
